var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffsetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#D8ECFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_514_496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2527 12.207L43.2412 16.7456",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3174 12.748L36.7865 17.169",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.876 17.5923L31.3923 20.7199",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9023 25.4229L28.5506 26.4105",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4561 34.1474L28.9839 32.7129",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.417 41.4138L32.6202 37.9805",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4375 45.2939L38.449 40.7554",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3725 44.753L44.9033 40.332",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8141 39.9089L50.2979 36.7812",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7879 32.078L53.1396 31.0903",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2339 23.3535L52.7061 24.788",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2735 16.0869L49.0703 19.5202",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8759 28.7387C50.8759 34.1473 46.3962 38.5213 40.8569 38.5213C35.3175 38.5213 30.8379 34.1473 30.8379 28.7387C30.8379 23.33 35.3175 18.9561 40.8569 18.9561C46.3721 18.9561 50.8759 23.3535 50.8759 28.7387Z",
    fill: "#9AC7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6575 45.811H25.9736V52.0192H31.6575V45.811Z",
    fill: "white",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7822 52.0195H35.8233",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0573 47.5282H7.54883C10.1017 41.9784 12.6787 36.4287 15.2317 30.8789H42.3745C44.9515 36.4287 47.5044 41.9784 50.0573 47.5282Z",
    fill: "white",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3428 40.7554H47.1674H10.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3428 40.7554H47.1674",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0645 35.5112H44.7832H13.0645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0645 35.5112H44.7832",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.976 30.8081C18.3142 36.3108 16.6765 41.79 15.0146 47.2928L19.976 30.8081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.976 30.8081C18.3142 36.3108 16.6765 41.79 15.0146 47.2928",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4322 30.8081C23.6133 36.3108 22.7944 41.79 21.9756 47.2928L24.4322 30.8081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4322 30.8081C23.6133 36.3108 22.7944 41.79 21.9756 47.2928",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9111 30.8081C28.9352 36.3108 28.9593 41.79 28.9593 47.2928L28.9111 30.8081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9111 30.8081C28.9352 36.3108 28.9593 41.79 28.9593 47.2928",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3672 30.8081C34.2101 36.3108 35.0772 41.79 35.9201 47.2928L33.3672 30.8081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3672 30.8081C34.2101 36.3108 35.0772 41.79 35.9201 47.2928",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8467 30.8081C39.5326 36.3108 41.2185 41.79 42.9043 47.2928L37.8467 30.8081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8467 30.8081C39.5326 36.3108 41.2185 41.79 42.9043 47.2928",
    stroke: "#0561FC",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_514_496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 41,
    fill: "white",
    transform: "translate(6 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffsetting);
export default __webpack_public_path__ + "static/media/offsetting.3238650fdba1ed1b81f345949365ca30.svg";
export { ForwardRef as ReactComponent };